import { type ParamExtractionActionConfig } from '@lighthouse/shared'

import { otherPlatformColorMap, otherPlatformIconMap } from '@/containers/OtherPlatforms/constant'
import { useGetAiModelList } from '@/shared/reusable'

import * as CM from '../styles'
import * as SC from './styles'

type ParameterExtractCardProps = {
    config: ParamExtractionActionConfig
}

const ParameterExtractCard = ({ config }: ParameterExtractCardProps) => {
    const { data } = useGetAiModelList()
    const { model } = config

    const aiModal = data?.find(item => item.modules.some(module => module.value === model))

    if (!aiModal) {
        return null
    }

    return (
        <CM.CardItemContainer>
            <CM.FieldList>
                <CM.FieldItem>
                    <SC.Icon type={otherPlatformIconMap[aiModal.type]} color={otherPlatformColorMap[aiModal.type]} size={16} />
                    <CM.FieldItemTitle>{model}</CM.FieldItemTitle>
                </CM.FieldItem>
            </CM.FieldList>
        </CM.CardItemContainer>
    )
}

export default ParameterExtractCard
